import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { FaKey, FaRegUser } from "react-icons/fa";
import { BsChatFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
import "../assets/css/SidebarModern.css";
import Api from '../api/Api';
import ModalAlterarSenha from "./Modalalterarsenha"; 


const { Sider } = Layout;

// ============ ÍCONES ============
const IconDashboard = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const IconTarefas = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <polyline points="9 11 12 14 22 4"/>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
  </svg>
);
const IconPresenca = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconLogistica = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="1" y="3" width="15" height="13" rx="1"/>
    <path d="M16 8h4l3 3v5h-7V8z"/>
    <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
  </svg>
);
const IconChat      = <BsChatFill size={16} />;
const IconColaboradores = <FaRegUser size={16} />;
const IconDirecoes = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IconMetricas = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);
const IconIniciativas = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);
const IconObjectivos = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);
const IconProjectos = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);
const IconUsuarios = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconCustos = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);
const IconAprovacao = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);
const IconFerias = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M17 18a5 5 0 0 0-10 0"/>
    <line x1="12" y1="9" x2="12" y2="2"/>
    <line x1="4.22" y1="10.22" x2="5.64" y2="11.64"/>
    <line x1="1" y1="18" x2="3" y2="18"/>
    <line x1="21" y1="18" x2="23" y2="18"/>
    <line x1="18.36" y1="11.64" x2="19.78" y2="10.22"/>
    <line x1="23" y1="22" x2="1" y2="22"/>
    <polyline points="8 6 12 2 16 6"/>
  </svg>
);
const IconFaltas = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

// ============ BUILDERS ============

/**
 * Menu de Logística — Aprovação só aparece para SECRETARIADO
 */
const buildLogistica = (perfil) => ({
  key: "logistica",
  icon: IconLogistica,
  label: "Logística",
  children: [
    { key: "/sala_reuniao", label: "Salas" },
    { key: "/transporte",   label: "Veículos" },
    ...(perfil === "SECRETARIADO" ? [{ key: "/aprovar", label: "Aprovação" }] : []),
  ],
});


const buildAssiduidade = (perfil) => ({
  key: "assiduidade_group",
   icon: IconPresenca,
  label: "RH",

    children: [
      { key: "/assiduidade_transacoes", label: "Presença" },
      { key: "/ferias",                 label: "Férias" },
      ...(perfil === "SECRETARIADO" ? [{ key: "/assiduidade", label: "Relatório de Assiduidade" }] : []),
    ],
});




const buildTarefas = (perfil) => ({
  key: "tarefas_group",
   icon: IconTarefas,
  label: "Tarefas",

    children: [
     { key: "/tarefas",         label: "Tarefas" },
      { key: "/tarefas_diarias", label: "Tarefas Diárias" },
      ...(perfil === "DIRETOR" || perfil ==="ADMINISTRACAO" ? [{ key: "/relatorio_semanal", label: "Relatório semanal" }] : []),
    ],
});




/**
 * Itens comuns a todos os perfis
 */
const buildCommonItems = (perfil) => [
  { key: "/projectos",             label: "Projectos",       icon: IconProjectos },
  /*{
    key: "tarefas_group",
    label: "Tarefas",
    icon: IconTarefas,
    children: [
      { key: "/tarefas",         label: "Tarefas" },
      { key: "/tarefas_diarias", label: "Tarefas Diárias" },
    ],
  },*/
  buildTarefas(perfil),
  buildAssiduidade(perfil),
  buildLogistica(perfil),
  { key: "/chat", label: "Next Chat", icon: IconChat },
];

// ============ MENU POR PERFIL ============

const getMenuByPerfil = (perfil) => {
  // Dashboard correto por perfil
  const dashboardKey =
    perfil === "DIRETOR"      ? "/dashboard_diretor"      :
    perfil === "ADMINISTRACAO" ? "/dashboard_administracao" :
    "/dashboard";

  const dashboardItem = {
    key: dashboardKey,
    label: "Dashboard",
    icon: IconDashboard,
  };

  const commonItems = buildCommonItems(perfil);

  switch (perfil) {

    // ── ADMINISTRACAO ─────────────────────────────────────────────────────────
    case "ADMINISTRACAO":
      return [
        dashboardItem,
        { key: "/iniciativas",  label: "Iniciativas",   icon: IconIniciativas },
        { key: "/objectivos",   label: "Objectivos",    icon: IconObjectivos },
        { key: "/direcoes",     label: "Direções",      icon: IconDirecoes },
        { key: "/colaboradores",label: "Colaboradores", icon: IconColaboradores },
        { key: "/custos",       label: "Custos",        icon: IconCustos },
        { key: "/aprovacao_ferias", label: "Aprovação Férias", icon: IconFerias },
          ...commonItems,
   
      
      ];

    // ── DIRETOR ───────────────────────────────────────────────────────────────
    case "DIRETOR":
      return [
        dashboardItem,
        {
          key: "aprovacoes_group",
          label: "Aprovações",
          icon: IconAprovacao,
          children: [
            { key: "/aprovar_faltas",      label: "Faltas",   icon: IconFaltas },
            { key: "/aprovacao_ferias",    label: "Férias",   icon: IconFerias },
            { key: "/tarefas_aprovacao",   label: "Tarefas",  icon: IconTarefas },
          ],
        },
        { key: "/iniciativas",  label: "Iniciativas",   icon: IconIniciativas },
        { key: "/objectivos",   label: "Objectivos",    icon: IconObjectivos },
        ...commonItems,
      ];

    // ── SECRETARIADO ──────────────────────────────────────────────────────────
    case "SECRETARIADO":
      return [
        dashboardItem,
        { key: "/aprovacao_ferias_secretariado", label: "Aprovação Férias", icon: IconFerias },
        ...commonItems,
      ];

    // ── ADMIN ─────────────────────────────────────────────────────────────────
    case "ADMIN":
      return [
        dashboardItem,
        { key: "/usuarios", label: "Usuários", icon: IconUsuarios },
        ...commonItems,
      ];

    // ── USUARIO (e qualquer outro perfil) ─────────────────────────────────────
    case "USUARIO":
    default:
      return [
        dashboardItem,
        ...commonItems,
      ];
  }
};

// ============ COMPONENTE ============

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const [perfil, setPerfil]       = useState(null);
  const [openKeys, setOpenKeys]   = useState([]);
  const [modalSenhaOpen, setModalSenhaOpen] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    const userStored = JSON.parse(localStorage.getItem("user"));
    if (!userStored) return;

    const perfilNormalizado = userStored.perfil?.trim()?.toUpperCase();
    setPerfil(perfilNormalizado);

    const menuFinal = getMenuByPerfil(perfilNormalizado);

    setMenuItems([
      ...menuFinal,
      { type: "divider" },
      {
        key:     "senha",
        icon:    <FaKey />,
        label:   "Alterar Senha",
          onClick: () => setModalSenhaOpen(true),   // ← ADICIONAR ESTA LINHA

         
      },
      {
        key:     "logout",
        icon:    <LogoutOutlined />,
        label:   "Sair",
        onClick: logout,
      },
    ]);
  }, []);

  // Accordion: só um submenu aberto de cada vez (nível raiz)
  const rootSubmenuKeys = [
    "tarefas_group",
    "assiduidade_group",
    "logistica",
    "aprovacoes_group",
  ];

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (rootSubmenuKeys.includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  return (
    <Sider
      className={`modern-sider ${collapsed ? "collapsed" : ""}`}
      collapsible
      collapsed={collapsed}
      trigger={null}
      width={270}
      collapsedWidth={82}
    >
      <div className="sidebar-logo" onClick={() => navigate("/dashboard")}>
        <img
          src={logo}
          alt="Logo"
          className={`logo-img ${collapsed ? "collapsed" : ""}`}
        />
      </div>

      <Menu
        key={perfil}
        mode="inline"
        className="modern-menu"
        items={menuItems}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onClick={({ key }) => {
          if (key === "logout" || key === "senha") return;
          navigate(key);
        }}
      />

      <ModalAlterarSenha
  open={modalSenhaOpen}
  onClose={() => setModalSenhaOpen(false)}
/>
    </Sider>
  );
};

export default Sidebar;